import React, { useCallback, useEffect, useState } from 'react';
import { Field } from 'react-final-form';

import Dropzone from '../Dropzone';
import { ValidationPopup } from 'components';

import useFiles from 'pages/CarePlans/hooks/useFiles';

const FormFileUploader = ({
  name,
  withTitle,
  placeholder = 'Choose file',
  postPlaceholder = '',
  maxFiles = null,
  singleFile = false,
  isInput = true,
  acceptedTypesProps,
  initialFiles = [],
  onFilesChange = (files) => {},
  helperText = 'Size maximum allowed is 10Mb',
  mainTextArray = ['images', 'video'],
  customValidation,
}) => {
  const [files, setFiles] = useState(initialFiles);
  const [open, setOpen] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const { onRemove, onPreSave, loading } = useFiles();

  const onLoadFile = async (images) => {
    const filesArr = images?.filter((item) => item.size);
    let uploadedFiles = [];
    if (singleFile) {
      uploadedFiles = filesArr.length
        ? await onPreSave({ record: { files: filesArr } })
        : [];
      setFiles([...uploadedFiles]);
    } else if (maxFiles) {
      if (files?.length < maxFiles) {
        uploadedFiles = await onPreSave({ record: { files: filesArr } });
        setFiles([...files.filter((item) => item.title), ...uploadedFiles]);
      }
    } else {
      if (filesArr?.length) {
        uploadedFiles = await onPreSave({ record: { files: filesArr } });
        setFiles([...files.filter((item) => item.title), ...uploadedFiles]);
      }
    }
  };

  const onDelete = useCallback(
    async (file) => {
      if (file.size) await onRemove({ records: { ids: [file.id] } });
      setFiles(files.filter((f) => f.id !== file.id));
    },
    [setFiles, files]
  );

  useEffect(() => {
    if (onFilesChange) onFilesChange(files);
  }, [files, onFilesChange]);

  const closeValidationPopup = () => {
    setOpen(false);
  };

  return (
    <>
      <Field name={name}>
        {({ input, meta }) => {
          return (
            <>
              <Dropzone
                onLoadFile={onLoadFile}
                files={files}
                onDelete={onDelete}
                onShowValidationError={setOpen}
                onSetValidationError={setValidationError}
                isInput={isInput}
                withTitle={withTitle}
                placeholder={placeholder}
                postPlaceholder={postPlaceholder}
                formInput={input}
                maxFiles={maxFiles}
                singleFile={singleFile}
                acceptedTypesProps={acceptedTypesProps}
                helperText={helperText}
                mainTextArray={mainTextArray}
                loading={loading}
                customValidation={customValidation}
              />
              <ValidationPopup
                open={open}
                onClose={closeValidationPopup}
                validationError={validationError}
              />
            </>
          );
        }}
      </Field>
    </>
  );
};

export default FormFileUploader;
